"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepeatBlockManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockManager = require("../BlockManager");
var _variables = require("@blockwell/variables");
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _spec = require("../spec");
var _remeda = require("remeda");
/**
 * A special manager for a repeat block that takes care of layout changes.
 */
class RepeatBlockManager extends _BlockManager.BlockManager {
  constructor(spec, type, childBlocks, registry) {
    super(spec, type, registry);
    (0, _defineProperty2.default)(this, "lastValue", void 0);
    (0, _defineProperty2.default)(this, "variables", void 0);
    (0, _defineProperty2.default)(this, "valueUpdate", value => {
      if (this.type.type === "repeat") {
        var _this$lastValue;
        let {
          list
        } = value;
        let lastList = (_this$lastValue = this.lastValue) === null || _this$lastValue === void 0 ? void 0 : _this$lastValue.list;
        if (!Array.isArray(lastList) || lastList.length !== list.length) {
          this.recreateBlocks(value);
        } else {
          for (let i = 0; i < list.length; i++) {
            let lastVal = lastList[i];
            let val = list[i];
            if (!(0, _fastDeepEqual.default)(lastVal, val)) {
              this.variables[i].set(val);
            }
          }
        }
      }
      this.lastValue = value;
    });
    this.childBlocks = childBlocks;
    type.events.on("value", this.valueUpdate);
  }
  recreateBlocks(value, retain) {
    let retainIndex = -1;
    let retainVariable;
    if (retain) {
      retainIndex = this.children.indexOf(retain);
      retainVariable = this.variables[retainIndex];
    }
    if (this.children.length > 0) {
      for (let it of this.children) {
        if (it !== retain) {
          it.removeContext();
          it.parent = undefined;
          it.destroyTree();
        }
      }
    }
    this.children = [];
    this.layout = [];
    this.variables = [];
    if (value) {
      let {
        list
      } = value;
      let i = 0;
      for (let val of list) {
        if (i === retainIndex) {
          this.variables.push(retainVariable);
          retain.parent = null;
          this.addChild(retain);
        } else {
          let writeable = new _variables.WriteableVariable("value");
          writeable.set(val);
          let variable = new _variables.VariableReference(writeable, {}, true);
          this.variables.push(writeable);
          let index = new _variables.VariableReference(new _variables.LiteralVariable(), {
            value: this.variables.length
          }, true);
          let layout = (0, _spec.addBlock)({
            type: "repeat-child"
          }, this.registry, this);
          layout.repeated = this.repeated || this.key;
          if (i > 0) {
            layout.context.repeated = true;
          }
          layout.context.addVariable(layout.key, "item", variable);
          layout.context.addVariable(layout.key, "index", index);
          (0, _spec.addBlocksFromSpec)(layout, this.childBlocks);
        }
        ++i;
      }
    }
    this.renderTree(true);
    this.emitLayout();
  }
  toSpec() {
    let block = this.toBlockSpec();
    if (this.children.length > 0) {
      // The immediate children are the repeat-child meta blocks, so we actually want
      // the children of that block
      block.children = this.children[0].children.map(it => it.toSpec());
    } else {
      block.children = [];
    }
    let spec = {
      block
    };
    return spec;
  }
  toJSON() {
    let block = (0, _remeda.clone)(this.spec);
    if (this.children.length > 0) {
      // The immediate children are the repeat-child meta blocks, so we actually want
      // the children of that block
      block.children = this.children[0].children.map(it => it.toJSON());
    } else {
      block.children = [];
    }
    return {
      block
    };
  }
  updateRepeatSpec(child) {
    if (super.updateRepeatSpec(this)) {
      return true;
    }

    // If super did not return true, this is the repeat block to change

    // We want the children of the child block, since child in this case is the
    // repeat-child or repeat-empty meta block
    this.childBlocks = child.children.map(it => it.toSpec());
    this.recreateBlocks(this.lastValue, child);
    return true;
  }
}
exports.RepeatBlockManager = RepeatBlockManager;
//# sourceMappingURL=RepeatBlockManager.js.map